import type { AddRegistryItemClickedProps } from '@apps/registry/common/components/Catalog/Catalog.telemetry.types';
import type { EventUserStatus } from '@graphql/generated-base';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { ShopRegionDialogDestination } from './components/ShopRegionDialog/ShopRegionDialog.types';

const category = 'shop';
const pagePrefix = 'newmarketing';

const telemObject = createTelemetryObject({
  pages: {
    eventPickerDialog: (membershipsCount: number) => ({
      category,
      pagePrefix,
      page: 'eventPickerDialog',
      extraPageInfo: {
        membershipsCount,
      },
    }),
    shopRegionDialog: (detectedLocale: string) => ({
      category,
      pagePrefix,
      page: 'shopRegionDialog',
      extraPageInfo: {
        detectedLocale,
      },
    }),
  },
  actions: {
    eventPickerSelect: (args: { role: EventUserStatus; membershipsCount: number; eventId: string }) => ({
      category,
      page: 'eventPickerDialog',
      pagePrefix,
      action: 'Event',
      actionType: 'select',
      extraInfo: {
        ...args,
      },
    }),
    shopAuthenticate: ({ page, ...restArgs }: AddRegistryItemClickedProps) => ({
      category,
      page,
      pagePrefix,
      label: restArgs.method,
      action: 'ShopAuthenticate',
      extraInfo: {
        ...restArgs,
      },
    }),
    shopRegionDialogContinue: (args: { detectedLocale: string; selectedLocale: string; destination: ShopRegionDialogDestination }) => ({
      category,
      page: 'shopRegionDialog',
      pagePrefix,
      action: 'ShopRegionDialogContinue',
      actionType: 'click',
      label: args.destination,
      extraInfo: {
        ...args,
      },
    }),
    shopRegionDialogExploreCashFunds: (args: { detectedLocale: string; selectedLocale: string }) => ({
      category,
      page: 'shopRegionDialog',
      pagePrefix,
      action: 'ShopRegionDialogExploreCashFunds',
      actionType: 'click',
      extraInfo: {
        ...args,
      },
    }),
    shopRegionDialogLocaleChanged: (args: { detectedLocale: string; selectedLocale: string }) => ({
      category,
      page: 'shopRegionDialog',
      pagePrefix,
      action: 'ShopRegionDialogLocale',
      actionType: 'select',
      label: args.selectedLocale,
      extraInfo: {
        ...args,
      },
    }),
    shopRegionDialogDismissed: (args: { detectedLocale: string; selectedLocale: string }) => ({
      category,
      page: 'shopRegionDialog',
      pagePrefix,
      action: 'ShopRegionDialogDismiss',
      actionType: 'click',
      extraInfo: {
        ...args,
      },
    }),
  },
});

const { TelemetryProvider: PublicShopTelemetryProvider, useTelemetry: usePublicShopTelemetry } = createTelemetry(telemObject);

export { PublicShopTelemetryProvider, usePublicShopTelemetry };
